module.exports = __webpack_public_path__ + "static/img/yyh.77b741d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classmates/yyh.png
// module id = M/c/
// module chunks = 41